import { UniqueEntityId } from "@kernel/ddd";
import { Device } from "../device";
import { Participant, ParticipantProps } from "./Participant";
import { ActiveDevice } from "./ActiveDevice";

export interface LocalParticipantProps extends ParticipantProps {
  activeDevice: ActiveDevice;
}

export class LocalParticipant extends Participant<LocalParticipantProps> {
  public get activeDevice(): ActiveDevice {
    return this.props.activeDevice;
  }

  public get audio(): Device | null {
    return this.props.activeDevice.audio;
  }

  public get camera(): Device | null {
    return this.props.activeDevice.video;
  }

  public isLocal(): boolean {
    return true;
  }

  public muteAudio(): void {
    this.activeDevice.muteAudio();
  }

  public unmuteAudio(): void {
    this.activeDevice.unmuteAudio();
  }

  public muteVideo(): void {
    this.activeDevice.muteVideo();
  }

  public unmuteVideo(): void {
    this.activeDevice.unmuteVideo();
  }

  public mute(): void {
    this.activeDevice.mute();
  }

  public unmute(): void {
    this.activeDevice.unmute();
  }

  public isAudioMuted(): boolean {
    return this.activeDevice.isAudioMuted();
  }

  public isVideoMuted(): boolean {
    return this.activeDevice.isVideoMuted();
  }

  public clone(): LocalParticipant {
    return new LocalParticipant(
      { ...this.props },
      new UniqueEntityId(this.id.toValue())
    );
  }

  public static create(
    props: LocalParticipantProps,
    id?: UniqueEntityId
  ): LocalParticipant {
    return new LocalParticipant(props, id);
  }
}
